import { render } from "./ConversationChipComponent.vue?vue&type=template&id=4ad957f8&scoped=true"
import script from "./ConversationChipComponent.vue?vue&type=script&lang=js"
export * from "./ConversationChipComponent.vue?vue&type=script&lang=js"

import "./ConversationChipComponent.vue?vue&type=style&index=0&id=4ad957f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad957f8"]])

export default __exports__